module.exports = __webpack_public_path__ + "static/sport/login.051cb69.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/login.gif
// module id = oIuv
// module chunks = 0